<template>
  <vue-delayed-multiselect-ajax
      :key="`${_uid}-tickets`"
      :custom-label="customLabel"
      :disabled="disabled"
      :name="name || 'farm_id'"
      :params="params"
      :placeholder="$t('Select {something}', { something: $t('tickets.singular') })"
      :required="required"
      :url="`/tickets`"
      :value="value"
      @loaded-response="onLoadedResponse"
      v-on="$listeners"
  >
    <template v-slot:beforeList>
      <slot
          name="beforeList"
          v-bind="{ canCreate, allowedActions: effectiveAllowedActions }"
      >
        <b-button
            v-if="canCreate"
            v-b-modal="`${_uid}-ticket-create-modal`"
            variant="link"
        >+
          {{ $t('Add new {something}', {something: $t('tickets.singular')}) }}
        </b-button>
        <ticket-create-modal
            v-if="canCreate"
            :id="`${_uid}-ticket-create-modal`"
            :key="`${_uid}-ticket-create-modal-${value}`"
            size="lg"
            @created="onInput($event.id)"
        ></ticket-create-modal>
      </slot>
    </template>
    <template v-slot:option="{ option }">
      <slot name="option" v-bind="{ option }"></slot>
    </template>
  </vue-delayed-multiselect-ajax>
</template>

<script>
import TicketCreateModal from '../modals/ticket-create';
import VueDelayedMultiselectAjax from "@/components/inputs/vue-delayed-multiselect-ajax.vue";

export default {
  name: 'ticket-select-ajax',
  components: {
    VueDelayedMultiselectAjax,
    TicketCreateModal,
  },
  props: {
    name: {
      type: String,
      default: undefined
    },
    value: {
      type: Number,
      default: undefined
    },
    allowedActions: {
      type: Array,
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: function () {
        return {
          with: 'creator',
        }
      }
    },
    initialValue: {
      type: Object,
      default() {
        return {};
      }
    },
    customLabel: {
      type: Function,
      default({
                id,
                customer_type,
                created_at,
                creator: {
                  name: creator_name
                } = {}
              }) {
        return `${id}: ${this.$t(`tickets.customer_types.${customer_type}`)}, ${this.$t('created_by_{name}_on_{date}', {
          name: creator_name,
          date: this.$moment.utc(created_at).local().format('DD MMMM YYYY')
        })}`
      }
    },
    loaded: {
      type: Function,
      default() {
        return () => {
        };
      }
    }
  },
  data() {
    return {
      resolvedAllowedActions: null,
    };
  },
  computed: {
    effectiveAllowedActions() {
      if (Array.isArray(this.allowedActions)) {
        return this.allowedActions;
      }

      if (Array.isArray(this.resolvedAllowedActions)) {
        return this.resolvedAllowedActions;
      }

      return null;
    },
    canCreate() {
      const allowedActions = this.effectiveAllowedActions;
      if (!Array.isArray(allowedActions)) {
        return true;
      }

      return allowedActions.includes("create") || allowedActions.includes("store");
    }
  },
  methods: {
    onLoadedResponse(response) {
      this.resolvedAllowedActions = Array.isArray(response?.data?.meta?.allowed_actions)
          ? response.data.meta.allowed_actions
          : null;
    },
    onInput(event) {
      this.$emit('input', event)
    },
    clearAll() {
      this.$emit('input', undefined)
    },
    x() {
      // window.console.log('loaded')
    }
  }
}
</script>

<style scoped>

</style>
